import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { updateLangConfig, LangConfig } from "store/Language/language.slice";
import C from "Constants";
import { useEffect } from "react";
import moment from "moment";

export function saveLanguageInformation(obj) {
  if (obj) {
    let val = JSON.stringify(obj);
    localStorage.setItem(C.LANG, val);
    sessionStorage.setItem(C.LANG, val);
  }
}

export function getLanguageInformation() {
  try {
    let dir = localStorage.getItem(C.LANG);
    if (dir) return JSON.parse(dir);
    else return dir;
  } catch (error) { }
}


function useLang({autoFetch = true} = {}) {
  const { langConfig } = useSelector((state) => state.LanguageSlice);
  const { i18n } = useTranslation();
  const dispatch = useDispatch();


  const handleLangChange = (langConfig) => {
    dispatch(updateLangConfig(langConfig));
    saveLanguageInformation(langConfig);
    i18n.changeLanguage(langConfig?.lang);
    document?.getElementsByTagName("html")[0].setAttribute("dir", langConfig?.direction);
    // document.body.dir = i18n.dir();
    moment.locale(langConfig?.lang);
  };

  useEffect(() => {
    if (autoFetch) {
      let defaultLang = LangConfig.EN;
      const obj = getLanguageInformation();
      if (obj?.lang && obj?.direction) {
      defaultLang = obj;
    }
      handleLangChange(defaultLang);
    }
  }, [autoFetch]);

  return {
    currentLang : langConfig?.code,
    isArabic : langConfig?.direction === "rtl",
    langConfig,
    handleLangChange,
  };
}

export default useLang;

export {
  LangConfig as Lang,
}
